module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAOVBMVEUAAABx0/9x0/9y0/973P9x0v9y0v9x0/9z1P9y0/9y0/9x0/9x0v/////y+//j9v/U8f+i4f+D1/+/qvxzAAAADHRSTlMA+fCRDt23UTXXYtZq13tIAAAAyUlEQVRIx7WWWw4CIQxFW8pDxvLc/2KNOsaZ+EFv1PN/IEDpLe34JDE7Zv2A2eUoydMRL04XODkol6AGwoV2NlYTvO3rsxrhxx4+qJlwP4cogBB5hwjOU1KIRIIJQhETImVMyOQwwRFjAuOCgvxIGL2W2odVmK08adMkzFpe1GkRWnnTDMIoR8Za6Cehr4V6EupaKGfgHeAzwLeEvgP+0ngtfV+tIP//03ibyZhwhVsl3Izhdg8HChpZcCiisQsHOz464MMJPP7cANGqZWhch9AQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduceIcon2.png
// module id = ldis
// module chunks = 1